import { render, staticRenderFns } from "./Korledarna.vue?vue&type=template&id=09c2d6dc&scoped=true&"
import script from "./Korledarna.vue?vue&type=script&lang=js&"
export * from "./Korledarna.vue?vue&type=script&lang=js&"
import style0 from "./Korledarna.vue?vue&type=style&index=0&id=09c2d6dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c2d6dc",
  null
  
)

export default component.exports